import { useState, useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import { Download, FileText } from "lucide-react";
import { Container, Reveal, PageBanner, siteImg } from "@/site/ui";

export default function Downloads() {
  const c = useOutletContext();
  const d = c.downloads || {};
  const items = d.items || [];
  const cats = useMemo(() => ["All", ...Array.from(new Set(items.map((i) => i.category).filter(Boolean)))], [items]);
  const [cat, setCat] = useState("All");
  const shown = cat === "All" ? items : items.filter((i) => i.category === cat);

  return (
    <div data-testid="downloads-page">
      <PageBanner image={c.banners?.downloads} eyebrow="Downloads" title={d.heading || "Downloads"} subtitle={d.subtitle} />

      <section className="py-16 md:py-24">
        <Container className="max-w-4xl">
          {cats.length > 2 && (
            <div className="mb-10 flex flex-wrap gap-2" data-testid="download-filters">
              {cats.map((a) => (
                <button key={a} onClick={() => setCat(a)}
                  className={`rounded-full px-5 py-2 text-sm font-medium transition-colors duration-200 ${cat === a ? "bg-[var(--rgh-primary)] text-white" : "bg-gray-100 text-[#525252] hover:bg-gray-200"}`}>
                  {a}
                </button>
              ))}
            </div>
          )}

          {shown.length === 0 ? (
            <div className="h-40 flex items-center justify-center rounded-2xl border border-dashed border-gray-200 text-[#A3A3A3]">No downloads available yet.</div>
          ) : (
            <div className="space-y-4">
              {shown.map((it, i) => (
                <Reveal key={it.id || i} delay={(i % 4) * 0.05}>
                  <div data-testid={`download-${i}`} className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-sm transition-shadow duration-200 hover:shadow-md">
                    <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[rgb(var(--rgh-primary-rgb)/0.08)] text-[var(--rgh-primary)]"><FileText size={22} /></span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2 flex-wrap">
                        <p className="text-base font-semibold text-[#0A0A0A]">{it.title}</p>
                        {it.category && <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-[11px] font-medium text-[#525252]">{it.category}</span>}
                      </div>
                      {it.desc && <p className="mt-0.5 text-sm text-[#525252] line-clamp-2">{it.desc}</p>}
                    </div>
                    {it.file ? (
                      <a href={siteImg(it.file)} target="_blank" rel="noreferrer" download data-testid={`download-btn-${i}`}
                        className="inline-flex shrink-0 items-center gap-2 rounded-full bg-[var(--rgh-primary)] px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[var(--rgh-primary-dark)]">
                        <Download size={16} /> <span className="hidden sm:inline">Download</span>
                      </a>
                    ) : <span className="text-xs text-[#A3A3A3]">Coming soon</span>}
                  </div>
                </Reveal>
              ))}
            </div>
          )}
        </Container>
      </section>
    </div>
  );
}
